import PropTypes from "prop-types"
import React from "react"

import AlertBanner from "src/components/AlertBanner"

import ReachOut from "../ReachOut"

const SigningFailedNotice = ({
  contractChatUrl,
  copy,
  marina,
  quoteId,
  reachOut,
}) => (
  <div className="flex flex-col gap-4">
    <AlertBanner type="error">{copy.body}</AlertBanner>
    {reachOut && marina && contractChatUrl && (
      <ReachOut
        reachOut={reachOut}
        contractChatUrl={contractChatUrl}
        marinaId={marina.id}
        marinaName={marina.name}
        quoteId={quoteId}
      />
    )}
  </div>
)

SigningFailedNotice.propTypes = {
  contractChatUrl: PropTypes.string,
  copy: PropTypes.shape({
    body: PropTypes.string.isRequired,
  }).isRequired,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  quoteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reachOut: PropTypes.shape({
    design: PropTypes.oneOf(["legacy", "needHelp"]).isRequired,
    mode: PropTypes.oneOf(["message", "call", "none"]).isRequired,
    phone: PropTypes.string,
    phoneUri: PropTypes.string,
  }),
}

export default SigningFailedNotice
